import { PlatformUtility } from 'utility-ts-platform';
import { SurveyStepService } from '../../data/services/survey_step_service';

export class SurveyStepViewContentController {
  private currentStepTitle: string;

  constructor(
    private myIntakeModel: any,
    private $state: ng.ui.IStateService,
    private ngSurveyStepService: SurveyStepService
  ) {}

  $onInit() {
    this.currentStepTitle = this.myIntakeModel.getCurrentPage().title;
  }

  getPage(index: number) {
    return this.myIntakeModel.pages[index];
  }

  gotoStep(step: number) {
    if (step < this.myIntakeModel.progression.index) {
      this.$state.go('my.majorexplorer-step', {
        pageIndex: step
      });
    }
  }
  onFormSubmit(event: JQueryEventObject) {
    if (event.key === 'Enter') {
      this.ngSurveyStepService.requestMoveToNext();
    }
  }
}

export class SurveyStepViewContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/survey_step_view_content/survey_step_view_content.html';
  public controller: any = SurveyStepViewContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_step_view_content/survey_step_view_content_controller.ts